import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Img } from "@/components/site/ServiceBlocks";

const SLIDES = [
  { img: "plant", eyebrow: "Dashboard-as-a-Service · Reports · Advisory", cta: ["/dashboards", "Open Dashboards"], cta2: ["/reports", "Browse Reports"] },
  { img: "dashboard", eyebrow: "Solution Dashboards", title: "Demand, prices, cost & capacity — one screen", sub: "Product-level market demand & forecast, cash cost of production, price trends, capacity tracker and CAPEX what-if calculator.", cta: ["/subscribe", "Subscribe"], cta2: ["/dashboards", "View Dashboards"] },
  { img: "lab", eyebrow: "Tech Transfer · Plant Advisory", title: "From technology transfer to plant transactions", sub: "Licensing & EPC liaisoning, buy-side and sell-side plant advisory, and post-transaction value creation.", cta: ["/tech-transfer", "Tech Transfer"], cta2: ["/plant-advisory", "Plant Advisory"] },
];

export function HeroCarousel({ home }) {
  const [i, setI] = useState(0);
  const [loaded, setLoaded] = useState([0]);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % SLIDES.length), 6500);
    const pre = setTimeout(() => setLoaded([0, 1, 2]), 1500);
    return () => { clearInterval(t); clearTimeout(pre); };
  }, []);
  const s = SLIDES[i];
  const title = s.title || home?.title || "Your Real-Time Chemical Market Intelligence Dashboard";
  const sub = s.sub || home?.subtitle;
  return (
    <section className="on-photo relative overflow-hidden h-[620px] md:h-[680px]" data-testid="home-hero-carousel">
      {SLIDES.map((sl, k) => (loaded.includes(k) || k === i) && (
        <div key={sl.img} className="absolute inset-0 transition-opacity duration-1000" style={{ opacity: k === i ? 1 : 0 }}>
          <Img name={sl.img} eager={k === 0} className={`h-full w-full object-cover ${k === i ? "scale-105" : "scale-100"} transition-transform duration-[7000ms]`} />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-[#090D16] via-[#090D16]/80 to-[#090D16]/10" />
      <div className="relative max-w-[1400px] mx-auto px-4 md:px-8 h-full flex flex-col justify-center" key={i}>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#F58B23] mb-5 fade-up">{s.eyebrow}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight max-w-3xl leading-[1.05] fade-up" data-testid="home-hero-title">{title}</h1>
        <p className="text-slate-200 mt-6 max-w-2xl text-base md:text-lg fade-up">{sub}</p>
        <div className="flex flex-wrap gap-3 mt-10 fade-up">
          <Link to={s.cta[0]} data-testid="home-cta-primary" className="px-6 py-3 rounded-md bg-[#1074BA] hover:bg-[#0D629E] text-white font-semibold flex items-center gap-2">{s.cta[1]} <ArrowRight className="h-4 w-4" /></Link>
          <Link to={s.cta2[0]} data-testid="home-cta-secondary" className="px-6 py-3 rounded-md border border-slate-400/60 hover:border-[#F58B23] text-white font-semibold backdrop-blur-sm">{s.cta2[1]}</Link>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2" data-testid="home-carousel-dots">
        {SLIDES.map((sl, k) => (
          <button key={sl.img} onClick={() => setI(k)} data-testid={`home-carousel-dot-${k}`} aria-label={`Slide ${k + 1}`}
            className={`h-1.5 rounded-full transition-all ${k === i ? "w-10 bg-[#F58B23]" : "w-5 bg-white/40 hover:bg-white/70"}`} />
        ))}
      </div>
    </section>
  );
}
